import React, { useEffect, useState } from 'react';
import './imageModal.scss';

const ImageModal = ({ closeModal, hasNext, hasPrev, findNext, findPrev, src, title, onlyImage }) => {
	const handleKeyDown = (e) => {
    if (e.keyCode === 27)
      this.props.closeModal();
    if (e.keyCode === 37 && this.props.hasPrev)
      this.props.findPrev();
    if (e.keyCode === 39 && this.props.hasNext)
      this.props.findNext();
  }

	return (
		<div className={`modal-img-container${src ? '' : '-close'}`}>
      <div style={{width:'100%',height:'100%'}} className="modal-img-overlay" onClick={closeModal}></div>
      <div style={{width:'100%',height:'500px'}} className="modal-img">
          <h3  className="text-bold text-center" style={{backgroundColor:'white'}} > {"    " +title} </h3>
        <div className='modal-img-body'>
          <a href="#" className='modal-img-close' onClick={closeModal} onKeyDown={handleKeyDown}>&times;</a>
          {hasPrev && <a href="#" className='modal-img-prev' onClick={findPrev} onKeyDown={handleKeyDown}>&lsaquo;</a>}
          {hasNext && <a href="#" className='modal-img-next' onClick={findNext} onKeyDown={handleKeyDown}>&rsaquo;</a>}

            {
                onlyImage ? ( <article className="article">
                    <picture className="picture">
                        <source media="(min-width: 0px)" srcSet={src} />
                        <img style={{width:'100%',height:'100%'}} src={  src} alt="background" />
                    </picture>
                    {/* <h1 className="huy-header">React Is Awesome</h1>*/}
                </article> ) : (<iframe    src={src} height='500px' width='100%' title={title}/>)
            }



        </div>
      </div>
    </div>
	);
};

export default ImageModal;
